var exports = {
  "kL": "xfd349460--c01c77--container",
  "iE": "xfd349460--c01c77--wrapper",
  "nV": "xfd349460--c01c77--gallery",
};

module.exports = exports;
